import React from 'react';

export default function AnnouncementBar() {
  return (
    <div className="bg-red-600 text-white text-xs sm:text-sm font-semibold tracking-wide py-2 px-4 text-center z-50 relative shadow-sm">
      <span className="uppercase">Notice:</span> Items are available for <span className="font-bold underline decoration-white/50 underline-offset-2">WHOLESALE</span> only. We do not sell items individually.
    </div>
  );
}
